/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Summary of student progress in a specific level
 */
export interface LevelEngagement {
  total: number;
  completed: number;
  taskStates: string[];
  taskIds?: string[];
}
